/**
 * AES-128 ECB 순수 JS 구현 — 배포용 HWP 복호화 전용.
 * 외부 의존성 없음 (kordoc 제로 네이티브 의존성 원칙 유지).
 * 참조: rhwp (MIT) src/parser/crypto.rs + FIPS-197 (AES 표준)
 */

// ── S-Box & 역 S-Box ──

const S_BOX = new Uint8Array([
  0x63,0x7c,0x77,0x7b,0xf2,0x6b,0x6f,0xc5,0x30,0x01,0x67,0x2b,0xfe,0xd7,0xab,0x76,
  0xca,0x82,0xc9,0x7d,0xfa,0x59,0x47,0xf0,0xad,0xd4,0xa2,0xaf,0x9c,0xa4,0x72,0xc0,
  0xb7,0xfd,0x93,0x26,0x36,0x3f,0xf7,0xcc,0x34,0xa5,0xe5,0xf1,0x71,0xd8,0x31,0x15,
  0x04,0xc7,0x23,0xc3,0x18,0x96,0x05,0x9a,0x07,0x12,0x80,0xe2,0xeb,0x27,0xb2,0x75,
  0x09,0x83,0x2c,0x1a,0x1b,0x6e,0x5a,0xa0,0x52,0x3b,0xd6,0xb3,0x29,0xe3,0x2f,0x84,
  0x53,0xd1,0x00,0xed,0x20,0xfc,0xb1,0x5b,0x6a,0xcb,0xbe,0x39,0x4a,0x4c,0x58,0xcf,
  0xd0,0xef,0xaa,0xfb,0x43,0x4d,0x33,0x85,0x45,0xf9,0x02,0x7f,0x50,0x3c,0x9f,0xa8,
  0x51,0xa3,0x40,0x8f,0x92,0x9d,0x38,0xf5,0xbc,0xb6,0xda,0x21,0x10,0xff,0xf3,0xd2,
  0xcd,0x0c,0x13,0xec,0x5f,0x97,0x44,0x17,0xc4,0xa7,0x7e,0x3d,0x64,0x5d,0x19,0x73,
  0x60,0x81,0x4f,0xdc,0x22,0x2a,0x90,0x88,0x46,0xee,0xb8,0x14,0xde,0x5e,0x0b,0xdb,
  0xe0,0x32,0x3a,0x0a,0x49,0x06,0x24,0x5c,0xc2,0xd3,0xac,0x62,0x91,0x95,0xe4,0x79,
  0xe7,0xc8,0x37,0x6d,0x8d,0xd5,0x4e,0xa9,0x6c,0x56,0xf4,0xea,0x65,0x7a,0xae,0x08,
  0xba,0x78,0x25,0x2e,0x1c,0xa6,0xb4,0xc6,0xe8,0xdd,0x74,0x1f,0x4b,0xbd,0x8b,0x8a,
  0x70,0x3e,0xb5,0x66,0x48,0x03,0xf6,0x0e,0x61,0x35,0x57,0xb9,0x86,0xc1,0x1d,0x9e,
  0xe1,0xf8,0x98,0x11,0x69,0xd9,0x8e,0x94,0x9b,0x1e,0x87,0xe9,0xce,0x55,0x28,0xdf,
  0x8c,0xa1,0x89,0x0d,0xbf,0xe6,0x42,0x68,0x41,0x99,0x2d,0x0f,0xb0,0x54,0xbb,0x16,
])

const INV_S_BOX = new Uint8Array([
  0x52,0x09,0x6a,0xd5,0x30,0x36,0xa5,0x38,0xbf,0x40,0xa3,0x9e,0x81,0xf3,0xd7,0xfb,
  0x7c,0xe3,0x39,0x82,0x9b,0x2f,0xff,0x87,0x34,0x8e,0x43,0x44,0xc4,0xde,0xe9,0xcb,
  0x54,0x7b,0x94,0x32,0xa6,0xc2,0x23,0x3d,0xee,0x4c,0x95,0x0b,0x42,0xfa,0xc3,0x4e,
  0x08,0x2e,0xa1,0x66,0x28,0xd9,0x24,0xb2,0x76,0x5b,0xa2,0x49,0x6d,0x8b,0xd1,0x25,
  0x72,0xf8,0xf6,0x64,0x86,0x68,0x98,0x16,0xd4,0xa4,0x5c,0xcc,0x5d,0x65,0xb6,0x92,
  0x6c,0x70,0x48,0x50,0xfd,0xed,0xb9,0xda,0x5e,0x15,0x46,0x57,0xa7,0x8d,0x9d,0x84,
  0x90,0xd8,0xab,0x00,0x8c,0xbc,0xd3,0x0a,0xf7,0xe4,0x58,0x05,0xb8,0xb3,0x45,0x06,
  0xd0,0x2c,0x1e,0x8f,0xca,0x3f,0x0f,0x02,0xc1,0xaf,0xbd,0x03,0x01,0x13,0x8a,0x6b,
  0x3a,0x91,0x11,0x41,0x4f,0x67,0xdc,0xea,0x97,0xf2,0xcf,0xce,0xf0,0xb4,0xe6,0x73,
  0x96,0xac,0x74,0x22,0xe7,0xad,0x35,0x85,0xe2,0xf9,0x37,0xe8,0x1c,0x75,0xdf,0x6e,
  0x47,0xf1,0x1a,0x71,0x1d,0x29,0xc5,0x89,0x6f,0xb7,0x62,0x0e,0xaa,0x18,0xbe,0x1b,
  0xfc,0x56,0x3e,0x4b,0xc6,0xd2,0x79,0x20,0x9a,0xdb,0xc0,0xfe,0x78,0xcd,0x5a,0xf4,
  0x1f,0xdd,0xa8,0x33,0x88,0x07,0xc7,0x31,0xb1,0x12,0x10,0x59,0x27,0x80,0xec,0x5f,
  0x60,0x51,0x7f,0xa9,0x19,0xb5,0x4a,0x0d,0x2d,0xe5,0x7a,0x9f,0x93,0xc9,0x9c,0xef,
  0xa0,0xe0,0x3b,0x4d,0xae,0x2a,0xf5,0xb0,0xc8,0xeb,0xbb,0x3c,0x83,0x53,0x99,0x61,
  0x17,0x2b,0x04,0x7e,0xba,0x77,0xd6,0x26,0xe1,0x69,0x14,0x63,0x55,0x21,0x0c,0x7d,
])

// ── RCON (라운드 상수) ──

const RCON = new Uint8Array([0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36])

// ── GF(2^8) 곱셈 ──

function gmul(a: number, b: number): number {
  let p = 0
  for (let i = 0; i < 8; i++) {
    if (b & 1) p ^= a
    const hi = a & 0x80
    a = (a << 1) & 0xff
    if (hi) a ^= 0x1b
    b >>= 1
  }
  return p
}

// ── 키 확장 (AES-128: 4 words → 44 words) ──

function expandKey(key: Uint8Array): Uint32Array {
  const w = new Uint32Array(44)

  // 첫 4 words: 원본 키
  for (let i = 0; i < 4; i++) {
    w[i] = (key[4 * i] << 24) | (key[4 * i + 1] << 16) | (key[4 * i + 2] << 8) | key[4 * i + 3]
  }

  for (let i = 4; i < 44; i++) {
    let temp = w[i - 1]
    if (i % 4 === 0) {
      // RotWord + SubWord + RCON
      temp = ((temp << 8) | (temp >>> 24)) >>> 0
      temp = (S_BOX[(temp >>> 24) & 0xff] << 24) |
             (S_BOX[(temp >>> 16) & 0xff] << 16) |
             (S_BOX[(temp >>> 8) & 0xff] << 8) |
              S_BOX[temp & 0xff]
      temp = (temp ^ (RCON[i / 4 - 1] << 24)) >>> 0
    }
    w[i] = (w[i - 4] ^ temp) >>> 0
  }

  return w
}

// ── AES-128 단일 블록 복호화 (16바이트) ──

function decryptBlock(block: Uint8Array, roundKeys: Uint32Array): Uint8Array {
  // state를 4x4 column-major 배열로 로드
  const s = new Uint8Array(16)
  for (let i = 0; i < 16; i++) s[i] = block[i]

  // AddRoundKey (round 10)
  addRoundKey(s, roundKeys, 10)

  // Rounds 9 → 1
  for (let round = 9; round >= 1; round--) {
    invShiftRows(s)
    invSubBytes(s)
    addRoundKey(s, roundKeys, round)
    invMixColumns(s)
  }

  // Final round (round 0)
  invShiftRows(s)
  invSubBytes(s)
  addRoundKey(s, roundKeys, 0)

  return s
}

function addRoundKey(s: Uint8Array, w: Uint32Array, round: number): void {
  const base = round * 4
  for (let c = 0; c < 4; c++) {
    const k = w[base + c]
    s[c * 4] ^= (k >>> 24) & 0xff
    s[c * 4 + 1] ^= (k >>> 16) & 0xff
    s[c * 4 + 2] ^= (k >>> 8) & 0xff
    s[c * 4 + 3] ^= k & 0xff
  }
}

function invSubBytes(s: Uint8Array): void {
  for (let i = 0; i < 16; i++) s[i] = INV_S_BOX[s[i]]
}

function invShiftRows(s: Uint8Array): void {
  // Row 0: no shift
  // Row 1: shift right 1
  let t = s[13]; s[13] = s[9]; s[9] = s[5]; s[5] = s[1]; s[1] = t
  // Row 2: shift right 2
  t = s[2]; s[2] = s[10]; s[10] = t
  t = s[6]; s[6] = s[14]; s[14] = t
  // Row 3: shift right 3 (= left 1)
  t = s[3]; s[3] = s[7]; s[7] = s[11]; s[11] = s[15]; s[15] = t
}

function invMixColumns(s: Uint8Array): void {
  for (let c = 0; c < 4; c++) {
    const i = c * 4
    const a0 = s[i], a1 = s[i + 1], a2 = s[i + 2], a3 = s[i + 3]
    s[i]     = gmul(a0, 0x0e) ^ gmul(a1, 0x0b) ^ gmul(a2, 0x0d) ^ gmul(a3, 0x09)
    s[i + 1] = gmul(a0, 0x09) ^ gmul(a1, 0x0e) ^ gmul(a2, 0x0b) ^ gmul(a3, 0x0d)
    s[i + 2] = gmul(a0, 0x0d) ^ gmul(a1, 0x09) ^ gmul(a2, 0x0e) ^ gmul(a3, 0x0b)
    s[i + 3] = gmul(a0, 0x0b) ^ gmul(a1, 0x0d) ^ gmul(a2, 0x09) ^ gmul(a3, 0x0e)
  }
}

// ── 공개 API ──

/** AES-128 ECB 복호화. data 길이는 16의 배수여야 함. */
export function aes128EcbDecrypt(data: Uint8Array, key: Uint8Array): Uint8Array {
  if (key.length !== 16) throw new Error("AES-128 키는 16바이트여야 합니다")
  if (data.length % 16 !== 0) throw new Error("AES ECB 입력은 16바이트의 배수여야 합니다")

  const roundKeys = expandKey(key)
  const out = new Uint8Array(data.length)

  for (let offset = 0; offset < data.length; offset += 16) {
    const block = data.subarray(offset, offset + 16)
    const decrypted = decryptBlock(block, roundKeys)
    out.set(decrypted, offset)
  }

  return out
}
